import queryString from 'querystring';
import _ from 'lodash';
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('ROOM_MEDIAS').plugin(axiosPlugin, {template: "array"});

let fetchRoomAction = redux.fetchActionGet();
redux.reducerForType('ADD', (state, action) => {
    let newState = {...state};
    newState.data = [action.payload,...newState.data];
    return newState;
});

redux.reducerForType('REMOVE', (state, action) => {
    let newState = {...state};
    let mediaId = _.get(action, '_id');
    newState.data = newState.data.filter(item => item._id.toString() !== mediaId.toString());
    return newState;
});


export const TYPES = redux.types;

export const fetchRoomMedias = (roomId, query = {}, more = false) => fetchRoomAction(`/rooms/${roomId}/medias?${queryString.stringify(query)}`, null, {more});
export const resetRoomMedias = () => redux.actions.reset();


export const roomMedias = redux.reducer();